import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {metrics} from '~/vendor/metrics';
import {useNavigate} from 'react-router-dom';

import embroideredOctopus from '~/assets/images/embroidery/octopus_embroidered.png';
import {
  Button,
  LightBulbIcon,
  Link,
  CheckIcon,
  IconButton,
  XCloseIcon
} from '@customink/pigment-react';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const EmbroideryModal = ({dismiss}) => {
  const navigate = useNavigate();

  useEffect(() => {
    metrics.pageViewTag('/ndx/designtip/embroidery');
  }, []);

  const handleCloseClicked = () => {
    metrics.pageViewTag('/ndx/designtip/embroidery/closed');
    dismiss();
  };

  const handleDoneClicked = () => {
    metrics.pageViewTag('/ndx/designtip/embroidery/confirm');
    dismiss();
  };

  const handleMouseDown = e => {
    e.stopPropagation();
  };
  const handleLinkClicked = () => {
    metrics.pageViewTag('/ndx/designtip/embroidery/help');
    dismiss();
    navigate('/help');
  };
  return (
    <div className="ndx-EmbroideryModal" onMouseDown={handleMouseDown}>
      <IconButton
        onClick={handleCloseClicked}
        className="ndx-EmbroideryModal-close"
        role="button"
        data-testid="close-button">
        <XCloseIcon />
      </IconButton>
      <div className="ndx-EmbroideryModal-content">
        <h1>Design Tips for Embroidered Products</h1>
        <p className="ndx-EmbroideryModal-content-summary">
          Embroidery is done by a machine that stitches threads directly into
          the product. Stick to these recommendations when adding your design or{' '}
          <Link onClick={handleLinkClicked}>reach out for help.</Link>
        </p>
        <div className="ndx-EmbroideryModal-container">
          <div className="ndx-EmbroideryModal-columns ndx-EmbroideryModal-tips-list">
            <ul className="ndx-EmbroideryModal-checked-list">
              {' '}
              <CheckIcon className="ndx-EmbroideryModal-check-icon" /> Keep your
              design simple
              <li>Small details aren’t captured well in stitching.</li>
            </ul>
            <ul className="ndx-EmbroideryModal-checked-list">
              {' '}
              <CheckIcon className="ndx-EmbroideryModal-check-icon" /> Choose a
              bold font
              <li>Thin lines in text will be hard to read.</li>
            </ul>
            <ul className="ndx-EmbroideryModal-checked-list">
              {' '}
              <CheckIcon className="ndx-EmbroideryModal-check-icon" /> Use solid
              colors
              <li>Halftones and gradients cannot be embroidered.</li>
            </ul>
          </div>
          <div className="ndx-EmbroideryModal-embroidered-content ndx-EmbroideryModal-columns">
            <div className="ndx-EmbroideryModal-content-tip">
              <span className="ndx-EmbroideryModal-content-tip-icon">
                <LightBulbIcon />
              </span>
              <span>
                Our artists will also adjust your image for the best results.
              </span>
            </div>
            <img
              className="ndx-EmbroideryModal-inky-image"
              src={embroideredOctopus}
            />
          </div>
        </div>
        <div className="ndx-EmbroideryModal-content-cta">
          <Button
            size="large"
            className="ndx-EmbroideryModal-content-cta-primary"
            onClick={handleDoneClicked}>
            Got It!
          </Button>
        </div>
      </div>
    </div>
  );
};

EmbroideryModal.displayName = 'EmbroideryModal';
const propTypes = {
  dismiss: PropTypes.func
};

EmbroideryModal.propTypes = propTypes;

export default EmbroideryModal;
